export function getCurrencyMeta(themeOrVariant) {
  const variant =
    typeof themeOrVariant === "string"
      ? themeOrVariant
      : themeOrVariant?.variant || themeOrVariant?.themeVariant || "";

  if (variant === "enterprise") {
    return {
      currency: "USD",
      locale: "en-US",
      symbol: "$",
    };
  }

  return {
    currency: "INR",
    locale: "en-IN",
    symbol: "₹",
  };
}

export function formatCurrencyAmount(value, themeOrVariant, options = {}) {
  const amount = Number(value);
  const { currency, locale, symbol } = getCurrencyMeta(themeOrVariant);
  const maximumFractionDigits = options.maximumFractionDigits ?? 2;
  const minimumFractionDigits =
    options.minimumFractionDigits ?? Math.min(2, maximumFractionDigits);

  if (!Number.isFinite(amount)) {
    return `${symbol}${currency === "USD" ? " " : ""}${minimumFractionDigits > 0 ? "0.00" : "0"}`;
  }

  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  });

  if (currency === "USD") {
    return formatter
      .formatToParts(amount)
      .map((part) => (part.type === "currency" ? `${part.value} ` : part.value))
      .join("");
  }

  return formatter.format(amount);
}
